//不寂寞授权
export const authority = () => {
  return [
    '/invite',
    '/vote/voteNumberPerson',
    '/vote/voteDescription',
    '/vote/voteQRCode',
    '/vote/voteDetails',
    '/vote/index',
    '/vote/updateImage',
    '/votedone',
    '/vote',
  ]
}
//美丽用户授权
export const mlzxAuthority = () => {
  return ['/storeDetail', '/bill', '/invite', '/forwxapp/successPage']
  //  return  ['/storeDetail', '/bill']
}
//美丽用户不用授权的页面路径
export const mlzxNotCheck = () => {
  return [
    'inShop',
    'chat',
    'addGuest',
    'order/index',
    'Appoint',
    'appointMe',
    'StoreAppoint',
    'importMobile',
    'setScheduleDate',
    'marketingprograms',
    'marketingprogram',     //免权限路径
    'MarketingShares',
    'vote/index',
    'commission',
    'percommission',
    'operStatement',
    'singleChat',
    'order/billing',
    'numberBand', 
    'AppointmentList',
    'voteIndex',
    'agentIndex',
    'chooseFaceImg'
  ]
}





// WEBPACK FOOTER //
// ./src/assets/js/NonSilenceUrl.js